import { Injectable, Injector } from "@angular/core";
import { FeatureName } from "@common/ADAPT.Common.Model/embed/feature-name.enum";
import { FeaturePermissionName } from "@common/ADAPT.Common.Model/embed/feature-permission-name.enum";
import { BaseService } from "@common/service/base.service";
import { AuthorisationService } from "@org-common/lib/authorisation/authorisation.service";
import { FeaturesService } from "@org-common/lib/features/features.service";
import { from } from "rxjs";
import { ISurveyAuthService } from "../survey-auth.service.interface";

@Injectable({
    providedIn: "root",
})
export class ResilientBusinessAssessmentAuthService extends BaseService implements ISurveyAuthService {
    public static readonly EditResilientBusinessAssessment = "editResilientBusinessAssessment";
    public static readonly ReadResilientBusinessAssessment = "readResilientBusinessAssessment";

    public constructor(
        injector: Injector,
        private authService: AuthorisationService,
        private featuresService: FeaturesService,
    ) {
        super(injector);
    }

    public static registerAccessVerifiers(authorisationService: AuthorisationService) {
        authorisationService.registerAccessVerifier(
            ResilientBusinessAssessmentAuthService.EditResilientBusinessAssessment,
            {
                requirePermissions: [
                    FeaturePermissionName.CulturalNetworkResilientBusinessAssessmentEdit,
                ],
            },
        );
        authorisationService.registerAccessVerifier(
            ResilientBusinessAssessmentAuthService.ReadResilientBusinessAssessment,
            {
                requirePermissions: [
                    FeaturePermissionName.CulturalNetworkResilientBusinessAssessmentEdit,
                    FeaturePermissionName.CulturalNetworkResilientBusinessAssessmentRead,
                ],
            },
        );
    }

    public isFeatureActive() {
        return this.featuresService.isFeatureActive(FeatureName.CulturalNetworkResilientBusinessAssessment);
    }

    public hasReadAccessToSurveys$() {
        return from(this.authService.promiseToGetHasAccess(ResilientBusinessAssessmentAuthService.ReadResilientBusinessAssessment));
    }

    public hasEditAccessToSurveys$() {
        return from(this.authService.promiseToGetHasAccess(ResilientBusinessAssessmentAuthService.EditResilientBusinessAssessment));
    }
}
